import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.2rem;
  background-color: ${props =>
    props.darker ? theme.grayLight : 'transparent'};
`

export const Text = styled.p`
  font-weight: ${props => (props.bold ? 'bold' : 400)};
  font-family: ${props =>
    props.variant ? theme.brandFontFamily : theme.bodyFontFamily};
  font-size: ${props => (props.variant ? theme.headingCheckout : '1rem')};
  margin: 0;
`
